import script from "./CustomTooltip.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomTooltip.vue?vue&type=script&setup=true&lang=js"

import "./CustomTooltip.vue?vue&type=style&index=0&id=16c37f09&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-16c37f09"]])

export default __exports__